export default __webpack_public_path__ + "static/media/male_02.51a94a2c.png";